<script setup>
import { computed, provide } from "vue"
import { storage } from '../../storage'

import UpgradeRowItem from './UpgradeRowItem'
const props = defineProps(['upgrade', 'keyName'])

provide('upgrade', props.upgrade)
provide('keyName', props.keyName)

const theDescription = computed(() => {
    const theUpgrade = props.upgrade
    if (theUpgrade && theUpgrade.values) {
        const index = storage.UPGRADES_LVLS[props.keyName] + 1
        const value = index >= theUpgrade.values.length ? theUpgrade.values[index - 1] : theUpgrade.values[index]
        return theUpgrade.description.replace('[value]', value)
    }
    return theUpgrade.description
})

const rowsNum = computed(() => props.upgrade.aliens ? props.upgrade.aliens : [null])

</script>

<template>
    <h4>{{ upgrade.name }}</h4>
    <div class="item" >
        <p>{{ theDescription }}</p>
        <UpgradeRowItem v-for="(row, ind) in rowsNum" :key="'row' + ind" :alienId="row" />
    </div>
</template>

<style scoped>
h4 {
    color: #e94d92;
    margin: 2px;
}

.item {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 5px;
    margin: 5px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.699);
    overflow: visible;
}

.item p {
    margin: 0 5px 5px;
}
</style>